import { Button, FieldContainer, Modal, Text, TextArea } from '@oy/uidesktop';
import { useSectionValidation } from 'src/components/Sidebar/hooks';
import { useTranslate } from 'src/hooks';
import { Chip } from '../../Chip';
import styles from './FeatureSuggestionModal.module.css';
import {
  CategoryLabel,
  FEATURE_SUGGESTION_MIN_TEXT_LENGTH,
  GENERAL_LABEL,
  categories,
} from './constants';
import { useFeatureSuggestionModal } from './useFeatureSuggestionModal';

export const FeatureSuggestionModal = ({
  show,
  onClose,
}: {
  show: boolean;
  onClose: () => void;
}) => {
  const { getTranslation } = useTranslate();
  const { isShowProduct } = useSectionValidation();

  const { state, onSelectCategory, onSubmit, closeModal, setText, setErrors } =
    useFeatureSuggestionModal(onClose);
  const { selectedCategories, text, errors } = state;

  const helpText = () => {
    if (errors.text) {
      return;
    }
    return text.length >= FEATURE_SUGGESTION_MIN_TEXT_LENGTH
      ? getTranslation('suggestFeature_helperafter20char')
      : getTranslation('feedbackForm_moreCharracters', {
          char: FEATURE_SUGGESTION_MIN_TEXT_LENGTH - text.length,
        });
  };

  const isShowChip = (label: CategoryLabel) =>
    GENERAL_LABEL.includes(label) || isShowProduct(label);

  return (
    <Modal show={show} onClose={closeModal} style={{ maxWidth: 480 }}>
      <Modal.Header showCloseButton showDivider>
        {getTranslation('suggestFeature_title')}
      </Modal.Header>
      <Modal.Body style={{ maxHeight: 'none' }}>
        <Text textStyle={Text.Style.BodyMdRegular}>
          {getTranslation('suggestFeature_description')}
        </Text>
        <form onSubmit={onSubmit}>
          <div>
            {categories.length > 0 && (
              <>
                <FieldContainer
                  name="suggestion-category"
                  errorMessage={errors.categories}
                  boldLabel
                  label={getTranslation('corporateCard_common_cardCategory')}
                  isRequired
                >
                  <div className={styles.categoriesContainer}>
                    {categories.map(category => {
                      if (!isShowChip(category.label)) return null;
                      return (
                        <Chip
                          key={category.value}
                          type="button"
                          onClick={() => onSelectCategory(category.value)}
                          active={selectedCategories.includes(category.value)}
                        >
                          {getTranslation(category.label)}
                        </Chip>
                      );
                    })}
                  </div>
                </FieldContainer>
              </>
            )}
            <TextArea
              name="suggestion_text"
              label={getTranslation('suggestFeature_describe_title')}
              boldLabel
              value={text}
              required
              onChange={e => {
                e.preventDefault();
                setText(e.target.value);
                setErrors({ ...errors, text: '' });
              }}
              placeholder={getTranslation(
                'suggestFeature_describe_placeholder',
              )}
              onBlur={() => {
                if (text.length < FEATURE_SUGGESTION_MIN_TEXT_LENGTH) {
                  setErrors({
                    ...errors,
                    text: getTranslation(
                      'feedbackForm_tellUsMore_errorMessage',
                    ),
                  });
                }
              }}
              errorMessage={errors.text}
              helpText={helpText()}
              helpTextAlign={
                text.length >= FEATURE_SUGGESTION_MIN_TEXT_LENGTH
                  ? 'left'
                  : 'right'
              }
            />
          </div>
          <Button fullWidth>{getTranslation('common_submit')}</Button>
        </form>
      </Modal.Body>
    </Modal>
  );
};
